import angular from 'angular';
import marketingAutomationSubs from './marketingAutomationSubs';

export default angular
  .module('components.marketingAutomationSubs', [])
  .component('marketingAutomationSubs', marketingAutomationSubs).name;
